// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.small {
  padding-left: 18px;
}

.small-field {
  flex-basis: 100px;
}

.medium-field {
  flex-basis: 325px;
}

.large-field {
  min-width: 0;
  max-width: 100%;
}

.extra-large-field {
  flex-basis: auto;
  min-width: 0;
  max-width: 100%;
}

.hidden {
  display: none;
}

.flex-item {
  width: 100%;
  max-width: 100%;
  /* Solo margen vertical: margin horizontal + width 100% desbordaba el modal */
  margin: 0.625rem 0;
  box-sizing: border-box;
  min-width: 0;
}

/* En modal crear informe: selects (p. ej. ORC) al 100% como texto y adjuntos */
.flex-item .input-group {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}
.flex-item .input-group > eview-searchable-select {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}
.flex-item .input-group > .form-control {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.flex-item eview-searchable-select,
.flex-item eview-tag-selector {
  display: block;
  width: 100%;
  max-width: 100%;
}

.flex-item .searchable-select,
.flex-item .searchable-select__input {
  width: 100%;
  max-width: 100%;
}

.small-field,
.medium-field,
.large-field,
.extra-large-field {
  width: 100%;
  max-width: 100%;
  flex-basis: auto;
  min-width: 0;
}

.location-container {
  display: flex;
  gap: 1em;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.location-container .location-input-container {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
.location-container .location-input-container .lat-lon-container {
  gap: 2em;
  display: flex;
}
.location-container .location-search-group__icon {
  background-color: #fff;
  border-right: 0;
  color: #6c757d;
  padding-left: 0.75rem;
  padding-right: 0.45rem;
}
.location-container .location-search-group__icon fa-icon {
  font-size: 0.9rem;
  opacity: 0.9;
}
.location-container .location-search-group__input {
  border-left: 0;
  padding-left: 0.35rem;
}
.location-container .location-search-group__input:focus {
  border-color: #ced4da;
  box-shadow: none;
}
.location-container .location-search-group__input.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: none;
}
.location-container .location-search-group:focus-within .location-search-group__icon {
  border-color: #80bdff;
}
.location-container .location-search-group:focus-within .location-search-group__input:not(.is-invalid) {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}
.location-container .map-container {
  height: 40vh;
  border: 1px solid #ced4da;
  border-bottom: none;
  border-top: none;
  border-radius: 10px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.loader {
  animation: rotation 0.8s infinite linear;
  color: #1a73e8;
  font-size: 16px;
  margin-right: 6px;
}

.loading-indicator {
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  padding: 0 12px !important;
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e8f0fe !important;
  border-color: #1a73e8 !important;
  transition: all 0.3s ease;
}
.loading-indicator.active {
  background-color: #e8f0fe !important;
}
.loading-indicator .loading-text {
  font-size: 13px;
  color: #1a73e8;
  font-weight: 500;
  white-space: nowrap;
}

.required {
  display: inline;
  font-size: 16px;
  font-weight: bold;
}

.pad-left-15 {
  padding-left: 15px;
}

.radio-group-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2.5em;
}

.radio-group-item {
  display: flex;
}

.datetime-input {
  width: 100%;
}
.datetime-input .form-control {
  max-width: 100%;
}

.file-upload-wrapper {
  display: inline-block;
}

.file-upload-label {
  content: "Cargar" !important;
  font-weight: normal !important;
}

.file-upload-label ::after {
  content: "Cargar" !important;
}

.custom-file-label {
  font-weight: normal !important;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Cargar" !important;
}

.file-error {
  color: #e53935;
  margin-top: 6px;
  font-size: 16px;
}

::ng-deep .search-result-item {
  padding: 8px 0;
}
::ng-deep .search-result-item .result-name {
  font-weight: 500;
  color: #202124;
  font-size: 14px;
}
::ng-deep .search-result-item .result-address {
  font-size: 12px;
  color: #5f6368;
  margin-top: 2px;
}

.analisis-section {
  margin-top: 0.25rem;
}

/* Título + instrucciones alineados como un solo bloque (mismo margen izquierdo que otros campos) */
.analisis-section__heading-block {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.2rem;
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 0;
}

.analisis-section__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.25rem 0.35rem;
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 16px;
  line-height: 1.35;
  color: var(--undp-jtf-btn-dark-color, #333);
}

.analisis-section__title {
  font-weight: unset;
}

.analisis-section__hint {
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.45;
  font-weight: 400;
  color: #6c757d;
}

.analisis-section__errors .file-error + .file-error {
  margin-top: 0.25rem;
}

/* Contenedor alineado con inputs Bootstrap del resto del formulario */
.analisis-section__body {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  padding: 0.75rem 0.875rem;
}
.analisis-section__body .input-group.mb-3:last-of-type {
  margin-bottom: 0 !important;
}
.analisis-section__body .input-group {
  flex-wrap: nowrap;
}
.analisis-section__body .custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}
.analisis-section__body .form-text {
  margin-bottom: 0;
}

/* Acción secundaria: agregar otro archivo (multi-adjuntos) */
.media-upload-actions {
  width: 100%;
}

.media-upload-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.55rem 0.85rem;
  border: 1px dashed #adb5bd;
  border-radius: 0.25rem;
  background-color: #f8f9fa;
  color: var(--undp-jtf-btn-dark-color, #495057);
  font-size: 0.9rem;
  line-height: 1.35;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.media-upload-add-btn:hover {
  background-color: #eef1f4;
  border-color: #868e96;
  color: var(--undp-jtf-btn-dark-color, #212529);
}
.media-upload-add-btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}
.media-upload-add-btn__icon {
  font-size: 0.85rem;
  opacity: 0.9;
}

.analisis-section__body .media-upload-add-btn {
  background-color: #fff;
  border-color: #ced4da;
}
.analisis-section__body .media-upload-add-btn:hover {
  background-color: #f5f6f8;
  border-color: #adb5bd;
}

.media-slot-row {
  flex-wrap: nowrap;
}
@media (max-width: 576px) {
  .media-slot-row {
    flex-wrap: wrap;
  }
  .media-slot-row .input-group-append {
    width: 100%;
    margin-top: 0.35rem;
    display: flex;
    justify-content: stretch;
  }
  .media-slot-row .media-slot-remove,
  .media-slot-row .media-slot-remove-row {
    flex: 1 1 auto;
    border-radius: 0.25rem !important;
  }
}

.media-single-upload {
  flex-wrap: nowrap;
}
.media-single-upload .custom-file {
  flex: 1 1 auto;
  min-width: 0;
}
.media-single-upload .media-single-upload__actions {
  flex-shrink: 0;
}

.media-slot-remove {
  white-space: nowrap;
  font-size: 0.8125rem;
  line-height: 1.35;
}

.media-slot-remove-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.35rem 0.55rem;
  margin: 0;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  color: var(--undp-jtf-btn-dark-color, #495057);
  font-size: 0.8125rem;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.media-slot-remove-row:hover {
  background-color: #f5f6f8;
  border-color: #adb5bd;
  color: var(--undp-jtf-btn-dark-color, #333);
}
.media-slot-remove-row:focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.12);
}
.media-slot-remove-row__icon {
  font-size: 0.75rem;
  opacity: 0.85;
}

/* Modal confirmación de adjunto: compacto y centrado en el ancho del contenido */
::ng-deep .media-upload-confirm-modal {
  z-index: 1070 !important;
}
::ng-deep .media-upload-confirm-modal .modal-dialog {
  max-width: min(100vw - 1.25rem, 780px);
  margin: 0.75rem auto;
  max-height: calc(100vh - 1.5rem);
}
::ng-deep .media-upload-confirm-modal .modal-content {
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  max-height: calc(100vh - 1.5rem);
  display: flex;
  flex-direction: column;
}
::ng-deep .media-upload-confirm-modal .modal-body {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
::ng-deep .media-upload-confirm-modal .modal-footer {
  padding: 0.65rem 1rem;
  border-top: 1px solid #eef0f2;
  gap: 0.5rem;
  flex-shrink: 0;
}
::ng-deep .media-upload-confirm-modal .modal-header {
  flex-shrink: 0;
}

.media-confirm-head {
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #eef0f2;
  align-items: center;
}
.media-confirm-head__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  line-height: 1.3;
  padding-right: 0.5rem;
}
.media-confirm-head__close {
  margin: 0;
  padding: 0.25rem;
  opacity: 0.55;
}
.media-confirm-head__close:hover {
  opacity: 1;
}

.media-confirm-body {
  padding: 1.1rem 1.25rem 1.15rem;
}

.media-confirm-preview {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fafbfc;
  overflow: hidden;
}
.media-confirm-preview__img {
  display: block;
  max-width: 100%;
  max-height: min(52vh, 480px);
  width: auto;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  padding: 0.75rem;
}
.media-confirm-preview__pdf-shell {
  width: 100%;
  height: min(68vh, 640px);
  min-height: 360px;
  background: #fff;
}
.media-confirm-preview__pdf {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.media-confirm-foot {
  justify-content: flex-end;
}

.media-slot-with-preview {
  width: 100%;
}

.media-multi-stack__list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
  padding: 0;
}
.media-multi-stack__item {
  list-style: none;
  margin: 0;
  padding: 0;
}
.media-multi-stack__card {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0.7rem 0.85rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.media-multi-stack__card:hover {
  border-color: #dee2e6;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.media-multi-stack__card-top {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0;
}
.media-multi-stack__type-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  color: #868e96;
}
.media-multi-stack__type-icon--pdf {
  color: #c92a2a;
}
.media-multi-stack__type-icon--image {
  color: #1864ab;
}
.media-multi-stack__body {
  flex: 1 1 auto;
  min-width: 0;
}
.media-multi-stack__name {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #212529;
  line-height: 1.35;
  word-break: break-word;
}
.media-multi-stack__btn-remove {
  flex-shrink: 0;
  margin-left: auto;
  padding: 0.35rem 0.45rem;
  line-height: 1;
  color: #868e96;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
}
.media-multi-stack__btn-remove:hover {
  color: #c92a2a;
  border-color: #ffc9c9;
  background: #fff5f5;
}
.media-multi-stack__btn-remove:focus {
  box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.15);
}
.media-multi-stack__picker {
  flex-wrap: nowrap;
}
.media-multi-stack__picker .custom-file {
  flex: 1 1 auto;
  min-width: 0;
}

.media-file-preview {
  margin-top: 0.5rem;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background-color: #f8f9fa;
}
.media-file-preview--single {
  max-width: 100%;
}
.media-file-preview__img {
  display: block;
  max-width: 100%;
  max-height: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-editor/form-attribute/form-attribute.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF;;AADA;EACE,iBAAA;AAIF;;AAFA;EACE,YAAA;EACA,eAAA;AAKF;;AAHA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAMF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,WAAA;EACA,eAAA;EACA,6EAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AAOF;;AAJA,+EAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AAOF;AALE;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAOJ;AAJE;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAMJ;;AAFA;;EAEE,cAAA;EACA,WAAA;EACA,eAAA;AAKF;;AAFA;;EAEE,WAAA;EACA,eAAA;AAKF;;AAFA;;;;EAIE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAKF;;AAFA;EACE,aAAA;EACA,QAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAKF;AAJE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAMJ;AAJI;EACE,QAAA;EACA,aAAA;AAMN;AADI;EACE,sBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;AAGN;AADM;EACE,iBAAA;EACA,YAAA;AAGR;AACI;EACE,cAAA;EACA,qBAAA;AACN;AACM;EACE,qBAAA;EACA,gBAAA;AACR;AAEM;EACE,qBAAA;EACA,gBAAA;AAAR;AAKM;EACE,qBAAA;AAHR;AAMM;EACE,qBAAA;EACA,gDAAA;AAJR;AASE;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;AAPJ;;AAWA;;EAEE,wBAAA;EACA,SAAA;AARF;;AAWA;EACE;IAEE,uBAAA;EARF;EAUA;IAEE,yBAAA;EARF;AACF;AAWA;EACE,wCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AATF;;AAYA;EACE,sCAAA;EAAA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,gCAAA;EACA,yBAAA;AATF;AAWE;EACE,oCAAA;AATJ;AAYE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;;AAcA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,WAAA;AAXF;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,qBAAA;AAZF;;AAeA;EACE,4BAAA;EACA,8BAAA;AAZF;;AAeA;EACE,4BAAA;AAZF;;AAeA;EACE,8BAAA;AAZF;;AAeA;EACE,4BAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAZF;;AAeA;EACE,cAAA;AAZF;AAcE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAZJ;AAeE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAbJ;;AAiBA;EACE,mBAAA;AAdF;;AAiBA,mGAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;AAdF;;AAiBA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,2CAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA,sEAAA;AACA;EACE,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;AAdF;AAgBE;EACE,2BAAA;AAdJ;AAiBE;EACE,iBAAA;AAfJ;AAkBE;EACE,qBAAA;EACA,gDAAA;AAhBJ;AAmBE;EACE,gBAAA;AAjBJ;;AAqBA,6DAAA;AACA;EACE,WAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,yBAAA;EACA,8CAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,kFAAA;AAlBF;AAoBE;EACE,yBAAA;EACA,qBAAA;EACA,8CAAA;AAlBJ;AAqBE;EACE,UAAA;EACA,gDAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,YAAA;AApBJ;;AAwBA;EACE,sBAAA;EACA,qBAAA;AArBF;AAuBE;EACE,yBAAA;EACA,qBAAA;AArBJ;;AAyBA;EACE,iBAAA;AAtBF;AAwBE;EAHF;IAII,eAAA;EArBF;EAuBE;IACE,WAAA;IACA,mBAAA;IACA,aAAA;IACA,wBAAA;EArBJ;EAwBE;;IAEE,cAAA;IACA,iCAAA;EAtBJ;AACF;;AA0BA;EACE,iBAAA;AAvBF;AAyBE;EACE,cAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,cAAA;AAxBJ;;AA4BA;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,wBAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gEAAA;AAzBF;AA2BE;EACE,yBAAA;EACA,qBAAA;EACA,2CAAA;AAzBJ;AA4BE;EACE,UAAA;EACA,iDAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,aAAA;AA3BJ;;AA+BA,iFAAA;AACA;EACE,wBAAA;AA5BF;AA8BE;EACE,sCAAA;EACA,oBAAA;EACA,gCAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;AA7BJ;AAgCE;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,qBAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;;AAoCA;EACE,qBAAA;EACA,gCAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAjCJ;AAoCE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AAlCJ;AAoCI;EACE,UAAA;AAlCN;;AAuCA;EACE,+BAAA;AApCF;;AAuCA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AApCF;AAsCE;EACE,cAAA;EACA,eAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AArCJ;AAwCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAtCJ;;AA0CA;EACE,yBAAA;AAvCF;;AA0CA;EACE,WAAA;AAvCF;;AA2CE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAxCJ;AA2CE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EACA,0DAAA;AA1CJ;AA4CI;EACE,qBAAA;EACA,4CAAA;AA1CN;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA5CJ;AA+CE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AA7CJ;AA+CI;EACE,cAAA;AA7CN;AAgDI;EACE,cAAA;AA9CN;AAkDE;EACE,cAAA;EACA,YAAA;AAhDJ;AAmDE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAjDJ;AAoDE;EACE,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAlDJ;AAoDI;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AAlDN;AAqDI;EACE,iDAAA;AAnDN;AAuDE;EACE,iBAAA;AArDJ;AAuDI;EACE,cAAA;EACA,YAAA;AArDN;;AA0DA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;AAvDF;AAyDE;EACE,eAAA;AAvDJ;AA0DE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AAxDJ","sourcesContent":[".small{\n  padding-left: 18px;\n}\n.small-field{\n  flex-basis:100px\n}\n.medium-field{\n  flex-basis: 325px;\n}\n.large-field {\n  min-width: 0;\n  max-width: 100%;\n}\n.extra-large-field {\n  flex-basis: auto;\n  min-width: 0;\n  max-width: 100%;\n}\n.hidden{\n  display: none\n}\n\n.flex-item {\n  width: 100%;\n  max-width: 100%;\n  /* Solo margen vertical: margin horizontal + width 100% desbordaba el modal */\n  margin: 0.625rem 0;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n/* En modal crear informe: selects (p. ej. ORC) al 100% como texto y adjuntos */\n.flex-item .input-group {\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n\n  > eview-searchable-select {\n    display: block;\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  > .form-control {\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n  }\n}\n\n.flex-item eview-searchable-select,\n.flex-item eview-tag-selector {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.flex-item .searchable-select,\n.flex-item .searchable-select__input {\n  width: 100%;\n  max-width: 100%;\n}\n\n.small-field,\n.medium-field,\n.large-field,\n.extra-large-field {\n  width: 100%;\n  max-width: 100%;\n  flex-basis: auto;\n  min-width: 0;\n}\n\n.location-container {\n  display: flex;\n  gap: 1em;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  flex-direction: row;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  .location-input-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n    \n    .lat-lon-container {\n      gap: 2em;\n      display: flex;\n    }\n  }\n\n  .location-search-group {\n    &__icon {\n      background-color: #fff;\n      border-right: 0;\n      color: #6c757d;\n      padding-left: 0.75rem;\n      padding-right: 0.45rem;\n\n      fa-icon {\n        font-size: 0.9rem;\n        opacity: 0.9;\n      }\n    }\n\n    &__input {\n      border-left: 0;\n      padding-left: 0.35rem;\n\n      &:focus {\n        border-color: #ced4da;\n        box-shadow: none;\n      }\n\n      &.is-invalid:focus {\n        border-color: #dc3545;\n        box-shadow: none;\n      }\n    }\n\n    &:focus-within {\n      .location-search-group__icon {\n        border-color: #80bdff;\n      }\n\n      .location-search-group__input:not(.is-invalid) {\n        border-color: #80bdff;\n        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);\n      }\n    }\n  }\n\n  .map-container {\n    height: 40vh;\n    border: 1px solid #ced4da;\n    border-bottom: none;\n    border-top: none;\n    border-radius: 10px;\n    min-width: 0;\n    max-width: 100%;\n    overflow: hidden;\n    margin: 0;\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n@keyframes rotation {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n.loader {\n  animation: rotation 0.8s infinite linear;\n  color: #1a73e8;\n  font-size: 16px;\n  margin-right: 6px;\n}\n\n.loading-indicator {\n  min-width: fit-content !important;\n  padding: 0 12px !important;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #e8f0fe !important;\n  border-color: #1a73e8 !important;\n  transition: all 0.3s ease;\n  \n  &.active {\n    background-color: #e8f0fe !important;\n  }\n  \n  .loading-text {\n    font-size: 13px;\n    color: #1a73e8;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n}\n\n.required {\n  display: inline;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.pad-left-15 {\n  padding-left: 15px;\n}\n\n.radio-group-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap:2.5em;\n}\n\n.radio-group-item {\n  display: flex;\n}\n\n.datetime-input {\n  width: 100%;\n\n  .form-control {\n    max-width: 100%;\n  }\n}\n\n.file-upload-wrapper {\n  display: inline-block;\n}\n\n.file-upload-label { \n  content: \"Cargar\"!important;\n  font-weight: normal !important;\n}\n\n.file-upload-label ::after{ \n  content: \"Cargar\"!important;\n}\n\n.custom-file-label {\n  font-weight: normal !important;\n}\n\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Cargar\"!important;\n}\n \n.file-error {\n  color: #e53935;\n  margin-top: 6px;\n  font-size: 16px;\n}\n\n::ng-deep .search-result-item {\n  padding: 8px 0;\n  \n  .result-name {\n    font-weight: 500;\n    color: #202124;\n    font-size: 14px;\n  }\n  \n  .result-address {\n    font-size: 12px;\n    color: #5f6368;\n    margin-top: 2px;\n  }\n}\n\n.analisis-section {\n  margin-top: 0.25rem;\n}\n\n/* Título + instrucciones alineados como un solo bloque (mismo margen izquierdo que otros campos) */\n.analisis-section__heading-block {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.2rem;\n  width: 100%;\n  margin-bottom: 0.5rem;\n  padding: 0;\n}\n\n.analisis-section__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.25rem 0.35rem;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  font-size: 16px;\n  line-height: 1.35;\n  color: var(--undp-jtf-btn-dark-color, #333);\n}\n\n.analisis-section__title {\n  font-weight: unset;\n}\n\n.analisis-section__hint {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  font-weight: 400;\n  color: #6c757d;\n}\n\n.analisis-section__errors .file-error + .file-error {\n  margin-top: 0.25rem;\n}\n\n/* Contenedor alineado con inputs Bootstrap del resto del formulario */\n.analisis-section__body {\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  background-color: #fff;\n  padding: 0.75rem 0.875rem;\n\n  .input-group.mb-3:last-of-type {\n    margin-bottom: 0 !important;\n  }\n\n  .input-group {\n    flex-wrap: nowrap;\n  }\n\n  .custom-file-input:focus ~ .custom-file-label {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);\n  }\n\n  .form-text {\n    margin-bottom: 0;\n  }\n}\n\n/* Acción secundaria: agregar otro archivo (multi-adjuntos) */\n.media-upload-actions {\n  width: 100%;\n}\n\n.media-upload-add-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.55rem 0.85rem;\n  border: 1px dashed #adb5bd;\n  border-radius: 0.25rem;\n  background-color: #f8f9fa;\n  color: var(--undp-jtf-btn-dark-color, #495057);\n  font-size: 0.9rem;\n  line-height: 1.35;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background-color: #eef1f4;\n    border-color: #868e96;\n    color: var(--undp-jtf-btn-dark-color, #212529);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);\n  }\n\n  &__icon {\n    font-size: 0.85rem;\n    opacity: 0.9;\n  }\n}\n\n.analisis-section__body .media-upload-add-btn {\n  background-color: #fff;\n  border-color: #ced4da;\n\n  &:hover {\n    background-color: #f5f6f8;\n    border-color: #adb5bd;\n  }\n}\n\n.media-slot-row {\n  flex-wrap: nowrap;\n\n  @media (max-width: 576px) {\n    flex-wrap: wrap;\n\n    .input-group-append {\n      width: 100%;\n      margin-top: 0.35rem;\n      display: flex;\n      justify-content: stretch;\n    }\n\n    .media-slot-remove,\n    .media-slot-remove-row {\n      flex: 1 1 auto;\n      border-radius: 0.25rem !important;\n    }\n  }\n}\n\n.media-single-upload {\n  flex-wrap: nowrap;\n\n  .custom-file {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .media-single-upload__actions {\n    flex-shrink: 0;\n  }\n}\n\n.media-slot-remove {\n  white-space: nowrap;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n}\n\n.media-slot-remove-row {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  padding: 0.35rem 0.55rem;\n  margin: 0;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  background-color: #fff;\n  color: var(--undp-jtf-btn-dark-color, #495057);\n  font-size: 0.8125rem;\n  line-height: 1.25;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background-color: #f5f6f8;\n    border-color: #adb5bd;\n    color: var(--undp-jtf-btn-dark-color, #333);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.12);\n  }\n\n  &__icon {\n    font-size: 0.75rem;\n    opacity: 0.85;\n  }\n}\n\n/* Modal confirmación de adjunto: compacto y centrado en el ancho del contenido */\n::ng-deep .media-upload-confirm-modal {\n  z-index: 1070 !important;\n\n  .modal-dialog {\n    max-width: min(100vw - 1.25rem, 780px);\n    margin: 0.75rem auto;\n    max-height: calc(100vh - 1.5rem);\n  }\n\n  .modal-content {\n    border-radius: 10px;\n    border: none;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n    max-height: calc(100vh - 1.5rem);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-body {\n    padding: 0;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n  }\n\n  .modal-footer {\n    padding: 0.65rem 1rem;\n    border-top: 1px solid #eef0f2;\n    gap: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  .modal-header {\n    flex-shrink: 0;\n  }\n}\n\n.media-confirm-head {\n  padding: 0.65rem 1rem;\n  border-bottom: 1px solid #eef0f2;\n  align-items: center;\n\n  &__title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #212529;\n    line-height: 1.3;\n    padding-right: 0.5rem;\n  }\n\n  &__close {\n    margin: 0;\n    padding: 0.25rem;\n    opacity: 0.55;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.media-confirm-body {\n  padding: 1.1rem 1.25rem 1.15rem;\n}\n\n.media-confirm-preview {\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  background: #fafbfc;\n  overflow: hidden;\n\n  &__img {\n    display: block;\n    max-width: 100%;\n    max-height: min(52vh, 480px);\n    width: auto;\n    height: auto;\n    margin: 0 auto;\n    object-fit: contain;\n    padding: 0.75rem;\n  }\n\n  &__pdf-shell {\n    width: 100%;\n    height: min(68vh, 640px);\n    min-height: 360px;\n    background: #fff;\n  }\n\n  &__pdf {\n    display: block;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n.media-confirm-foot {\n  justify-content: flex-end;\n}\n\n.media-slot-with-preview {\n  width: 100%;\n}\n\n.media-multi-stack {\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    margin: 0 0 0.85rem;\n    padding: 0;\n  }\n\n  &__item {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  &__card {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 0.7rem 0.85rem;\n    background: #fff;\n    border: 1px solid #e9ecef;\n    border-radius: 10px;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: #dee2e6;\n      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n    }\n  }\n\n  &__card-top {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    min-width: 0;\n  }\n\n  &__type-icon {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.05rem;\n    color: #868e96;\n\n    &--pdf {\n      color: #c92a2a;\n    }\n\n    &--image {\n      color: #1864ab;\n    }\n  }\n\n  &__body {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__name {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #212529;\n    line-height: 1.35;\n    word-break: break-word;\n  }\n\n  &__btn-remove {\n    flex-shrink: 0;\n    margin-left: auto;\n    padding: 0.35rem 0.45rem;\n    line-height: 1;\n    color: #868e96;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    background: #fff;\n\n    &:hover {\n      color: #c92a2a;\n      border-color: #ffc9c9;\n      background: #fff5f5;\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.15);\n    }\n  }\n\n  &__picker {\n    flex-wrap: nowrap;\n\n    .custom-file {\n      flex: 1 1 auto;\n      min-width: 0;\n    }\n  }\n}\n\n.media-file-preview {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  background-color: #f8f9fa;\n\n  &--single {\n    max-width: 100%;\n  }\n\n  &__img {\n    display: block;\n    max-width: 100%;\n    max-height: 200px;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n    border-radius: 0.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
